export default "/images/d6d1bfab9d6596ebc09cfe896d284572.avif";